import Flex from '@Components/Bases/Flex';
import { FormDatePicker } from '@Components/Form';
import FormSelect from '@Components/Form/FormSelect';
import {
  disabledDatePickerTypingStyles,
  disabledFormInputStyles,
} from '@Components/Form/styles';
import { MenuItem, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useFormContext } from 'react-hook-form';
import { ReportType } from 'src/Enum/Report';
import { CreateReportFormValues } from './CreateReportModal';
import { durationYearOptions } from './utils';

const DurationYearForm = () => {
  const { setValue, watch } = useFormContext<CreateReportFormValues>();

  const selectedYear = watch('reportType');
  const currentYear = dayjs().startOf('year');

  const startOperatingYear = watch('startOperatingYear');

  const canEditStartYear =
    startOperatingYear && startOperatingYear.year() !== currentYear.year();

  return (
    <>
      <Typography fontWeight="bold">ระยะเวลาจัดทำโครงการ</Typography>
      <Flex width={'100%'} gap={2} alignItems={'baseline'}>
        <Flex alignItems={'baseline'}>
          <FormSelect
            name="reportType"
            placeholder="กรุณาเลือกระยะเวลาเป้าหมาย"
            onChange={(event) => {
              const value = event.target.value as ReportType;
              setValue('reportType', value);
            }}
            sx={{ width: '100px' }}
          >
            {durationYearOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </FormSelect>
        </Flex>

        {selectedYear === ReportType.RANGE && (
          <>
            <Flex gap={0.5} alignItems={'baseline'} sx={{ width: '450px' }}>
              <FormDatePicker
                placeholder="กรุณาเลือกปีเริ่มต้น"
                name="startOperatingYear"
                views={['year']}
                format="BBBB"
                minDate={currentYear ?? undefined}
                maxDate={currentYear}
                sx={[
                  { width: '100%' },
                  !canEditStartYear
                    ? disabledFormInputStyles
                    : disabledDatePickerTypingStyles,
                ]}
                slotProps={{
                  toolbar: { hidden: false },
                  openPickerButton: {
                    sx: {
                      opacity: canEditStartYear ? 1 : 0.5,
                    },
                  },
                }}
                localeText={{ toolbarTitle: 'เลือกปีเริ่มต้น' }}
              />

              <Typography pt={0.5}>{'\u2014'}</Typography>

              <FormDatePicker
                placeholder="กรุณาเลือกปีที่สิ้นสุด"
                name="endOperatingYear"
                views={['year']}
                format="BBBB"
                disablePast
                sx={[{ width: '100%' }, disabledDatePickerTypingStyles]}
                minDate={currentYear.add(1, 'year')}
                maxDate={currentYear.add(9, 'year')}
                slotProps={{ toolbar: { hidden: false } }}
                localeText={{ toolbarTitle: 'เลือกปีที่สิ้นสุด' }}
              />
            </Flex>
          </>
        )}

        {selectedYear === ReportType.SINGLE && (
          <FormDatePicker
            placeholder="กรุณาเลือกระยะเวลาเป้าหมาย"
            name="startOperatingYear"
            views={['year']}
            format="BBBB"
            minDate={currentYear ?? undefined}
            maxDate={currentYear}
            sx={[
              { width: '450px' },
              !canEditStartYear
                ? disabledFormInputStyles
                : disabledDatePickerTypingStyles,
            ]}
            slotProps={{
              toolbar: { hidden: false },
              field: {
                clearable: !canEditStartYear,
              },
              openPickerButton: {
                sx: {
                  opacity: canEditStartYear ? 1 : 0.5,
                },
              },
            }}
            localeText={{ toolbarTitle: 'เลือก ปี' }}
          />
        )}
      </Flex>
    </>
  );
};

export default DurationYearForm;
